import React, { ButtonHTMLAttributes, FC, SVGProps } from 'react';
import { Center, Tooltip, TooltipProps, UnstyledButton } from '@mantine/core';
import classNames from 'classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	Icon: FC<SVGProps<SVGSVGElement>>;
	tooltipProps: Omit<TooltipProps, 'children'>;
}

export const ToolbarButton: React.FC<Props> = ({
	Icon,
	tooltipProps,
	...buttonProps
}) => {
	return (
		<Tooltip {...tooltipProps}>
			<UnstyledButton
				{...buttonProps}
				className={classNames('toolbar-btn', buttonProps.className)}
			>
				<Center>
					<Icon />
				</Center>
			</UnstyledButton>
		</Tooltip>
	);
};
